import React from 'react';
import StakingSectionsSections from '../../components/PTGC/staking/index';  // ✅ Fix import

const StakingSectionsPage = () => {
  return (
    <>
      <StakingSectionsSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default StakingSectionsPage;